import React from "react";
import { Breadcrumb } from "react-bootstrap";
import "./index.scss";
const PageHeader = ({ title, breadcrumb }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <h4 className=" breadcrumb-title">{title}</h4>
      <Breadcrumb>
        {breadcrumb.map((item, idx) => (
          <Breadcrumb.Item
            key={idx}
            active={idx === breadcrumb.length - 1}
            href={item.href || "#"}>
            {item.label}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};

export default PageHeader;
